export interface TimelineEvent {
    id: number;
    title: string;
    description: string;
    location: string;
    startdate: Date;
    enddate?: Date;
    link?: string;
  }

  export const timelineEvents: TimelineEvent[] = [
    {
        id: 1,
        title: "Internship with Embeddeers GmbH",
        description: "Requirements engineering and software development according to ISO 15504 using the V-model. Using processes, verification, and different levels of validation to develop software that meets the highest quality standards and is suitable for use in safety-critical applications. Managed the integration of Volkswagen development requirements into the current development process.",
        location: "Berlin, Germany",
        startdate: new Date("2023-05-31T05:00:00.000+00:00"),
        enddate: new Date("2023-07-18T05:00:00.000+00:00"),
        link: "https://www.embeddeers.com/en/"
    },

    {
        id: 2,
        title: "BS in Computer Science at Lafayette College",
        description: "Expected Graduation in May, 2025",
        location: "Easton, PA",
        startdate: new Date("2021-08-31T05:00:00.000+00:00"),
        enddate: new Date("2025-05-24T05:00:00.000+00:00"),
        link: "https://www.lafayette.edu/"
    },

    {
        id: 3,
        title: "Solebury Prepatory High School Graduation",
        description: "Studied at a small performing arts focused prepatory high school",
        location: "New Hope, PA",
        startdate: new Date("2018-08-26T05:00:00.000+00:00"),
        enddate: new Date("2021-05-25T05:00:00.000+00:00"),
        link: "https://www.solebury.org/",
    },

    {
        id: 4,
        title: "Volunteer English Tutor Abroad",
        description: "Traveled to Costa Rica with a school sponsored program, volunteering as an English tutor serving underprivileged Spanish-speaking community.",
        location: "Guanacaste, Costa Rica",
        startdate: new Date("2018-03-25T05:00:00.000+00:00"),
        enddate: new Date("2018-04-03T05:00:00.000+00:00"),
        link: "https://abriendomentes.org/",
    },

    {
        id: 5,
        title: "Data Structures and Algorithms Tutor",
        description: "Providing peer tutoring support for classmates studying data structures and algorithms with Java and Object Oriented Techniques while coaching peers to develop study skills for success as Computer Science majors.",
        location: "Easton, PA",
        startdate: new Date("2023-08-30T05:00:00.000+00:00"),
        enddate: new Date("2024-01-01T05:00:00.000+00:00"),
        link: ""
    },

    {
        id: 6,
        title: "Commercial Data Science Intern, Bristol Myers Squibb",
        description: "Collaborating to provide engineering support for Commercialization Data Science and AI Predictive Solutions. Supported the engineering of upstream data science pipelines to enhance workflow efficiency and model performance. Analyzed unexplored datasets to identify potential impacts, optimize existing modeling approaches, and develop strategic recommendations for improvement.",
        location: "Lawrenceville, New Jersey",
        startdate: new Date("2024-05-20T05:00:00.000+00:00"),
        enddate: new Date("2024-08-16T05:00:00.000+00:00"),
    },
  ];